import React from "react";
import moment from "moment";
import { CTA } from "@coverme/forms";
import { formatCurrency } from "../../services/moneyFormatter";

const TableRow = ({ title, value }) => {
    return (
        <tr>
            <td>{title}</td>
            <td>{value}</td>
        </tr>
    );
};

export const PayaReceipt = ({ paymentDetails }) => {
    function print() {
        const printStyle = `
        <style>
            .paya-table {
                font-size: 1.6rem;
                border-collapse: collapse;
            }

            tr, td {
                    border: 1px solid black;
                    padding: 5px;
            }
        </style>
        `;
        const contentToPrint = document.getElementById("paya-table");
        const printWindow = window.open("", "", "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0");
        printWindow.document.write(printStyle);
        printWindow.document.write(contentToPrint.outerHTML);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    }
    return (
        <div id="paya-receipt-header">
            <div className="page-header">
                <h2>Payment Receipt</h2>
                <a onClick={print} href="javascript:void(0)" className="print-receipt">
                    Print
                </a>
            </div>
            <table className="paya-table" id="paya-table">
                <TableRow title="Transaction Amount" value={formatCurrency(paymentDetails?.transactionAmount)} />
                <TableRow title="Transaction Type" value={paymentDetails?.accountType} />
                <TableRow title="Transaction Status" value={paymentDetails?.transactionStatus} />
                <TableRow title="Transaction Verbiage" value={paymentDetails?.transactionVerbiage} />
                <TableRow title="Reason" value={paymentDetails?.reasonCode} />
                <TableRow title="Auth Code" value={paymentDetails?.authCode} />
                <TableRow title="Account Holder" value={paymentDetails?.accountHolderName} />
                <TableRow title="Last 4 Digits" value={paymentDetails?.lastFour} />
                <TableRow title="Entry Mode" value={paymentDetails?.entryMode} />
                <TableRow title="Description" value={paymentDetails?.description} />
                <TableRow title="Tags" value={paymentDetails.tags} />
                <TableRow
                    title="CreatedDate"
                    value={moment(paymentDetails?.createdDate).format("MM-DD-YYYY hh:mm:ssA")}
                />
                <TableRow title="Transaction Id" value={paymentDetails?.transactionId} />
            </table>
        </div>
    );
};
